/**
 * created by 韩国旗
 * 融媒发布
 *
 */
import ShortVideo from "../components/ShortVideo";
import KuaiShou from "../quickHand/KuaiShou";
import ReleaseMedia from '../releaseMedia/ReleaseMedia'
import MediaConnectionPage from "../components/MediaConnectionPage";
import NetworkMediaJump from '../mediaJump/NetworkMediaJump'
import NotColumnPage from "../releaseMedia/NotColumnPage";
import ImageSourceList from "../imageSource/ImageSourceList";
import LinkSourceList from "../linkSource/linkSourceList";
import DraftBox from "../draftBox/draftBox";
import AllWeiboList from "../microblog/AllWeiboList";
import TikTok from "../tikTok/tikTok"
import WeiChatPublish from "../weChatPublish/WeChatPublish";
import PublishRecord from "../publishRecord/publishRecord";
// import BaiJiaHao from "../baijiahao/BaiJiaHao";
import MineOrAllManuscript from "../websiteManage/MineOrAllManuscript";
export const mediaReleaseRouter =[
    // {
    //     path:'/view/mediaRelease/ShortVideo',
    //     componentTitle: "融媒体发布抖音,快手共用组件",
    //     component:ShortVideo
    // },
    // {
    //     path:'/view/releaseMedia/components/mediaConnectionPage',
    //     componentTitle: "融媒体发布网站组件",
    //     component:MediaConnectionPage
    // },
    {
        path:'/view/releaseMedia/releaseMedia',
        componentTitle: "融媒体发布媒体列表",
        component:ReleaseMedia
    },
    {
        path:'/website/column',
        component:NotColumnPage
    },
    {
        path:'/website/column/:mediaId',
        component:NotColumnPage
    },
    {
        path:'/website/column/:mediaId/:treeId/news/:contentId',
        componentTitle: "网站文章源列表",
        component:NetworkMediaJump
    },
    {
        path:'/website/column/:mediaId/:treeId/image/:contentId',
        componentTitle: "网站图片源列表",
        component:ImageSourceList
    },
    {
        path:'/website/column/:mediaId/:treeId/url/:contentId',
        componentTitle: "网站链接源列表",
        component:LinkSourceList
    },
    {
        path:'/view/mediaRelease/quickHead/:mediaId',
        componentTitle: "融媒体发布快手页面",
        component:KuaiShou
    },
    {
        path:'/website/undo/:mediaId',
        componentTitle: "撤稿箱",
        component:DraftBox
    },
    {
        path:"/weibo/:mediaId",
        componentTitle: "微博",
        component: AllWeiboList
    },
    {
        path:'/douyin/:mediaId',
        componentTitle: "融媒体发布抖音页面",
        component:TikTok
    },
    // 微信发布
    {
        path:"/wechat/weiChatPublish/:currentMedia",
        componentTitle: "公众号",
        component:WeiChatPublish
    },
    // 微信群发消息
    {
        path:"/wechat/publishRecord/:currentMedia",
        componentTitle: "微信群发消息",
        component:PublishRecord
    },
    // {
    //     path:"/baiJiaHao/:mediaId",
    //     componentTitle: "百家号",
    //     component: BaiJiaHao
    // },
    {
        path:"/websiteManage/manuscript/:mediaId",
        componentTitle: "全部稿件",
        component: MineOrAllManuscript
    },
    {
        path:"/websiteManage/manuscript/:mine/:mediaId",
        componentTitle: "我的稿件",
        component: MineOrAllManuscript
    },
];